/**
 * Hues for telling sections APART, none of which mean anything in this product.
 *
 * Green, amber and red are spoken for — they are the four risk levels, on every
 * badge and every score — so a palette for variety has to stay out of them, or a
 * card claims a severity by being a colour. These are blues, indigos, violets,
 * cyans and slates: distinguishable from each other, and adjacent to nothing
 * that carries meaning.
 *
 * Plain data in its own module because `CardIcon.tsx` exports a component, and
 * react-refresh warns when a file mixes the two.
 */
const HUES = {
  blue: { light: '#2563EB', dark: '#60A5FA' },
  indigo: { light: '#4F46E5', dark: '#818CF8' },
  violet: { light: '#7C3AED', dark: '#A78BFA' },
  cyan: { light: '#0E7490', dark: '#22D3EE' },
  steel: { light: '#0369A1', dark: '#38BDF8' },
  plum: { light: '#A21CAF', dark: '#E879F9' },
  slate: { light: '#475569', dark: '#94A3B8' },
} as const;

export type CardHue = keyof typeof HUES;

export function hueColor(hue: CardHue, dark: boolean): string {
  return HUES[hue][dark ? 'dark' : 'light'];
}
